import * as React from 'react';
import { Divider } from './Divider';
import { Card } from './Card';
import { Button } from './button/Button';
import { AnimatedCollapsibleContent } from './collapsible/AnimatedCollapsibleContent';

type PageSectionProps = {
    header?:React.ReactNode,
    children:React.ReactNode,
    defaultCollapsed?:boolean, // Set this to enable collapse button
    onCollapse?:(collapsed:boolean)=>void,
}

export function PageSection(props:PageSectionProps):JSX.Element
{
    const [collapsed, setCollapsed] = React.useState<boolean>(props.defaultCollapsed || undefined);
    React.useEffect(()=>{
        if(props.defaultCollapsed !== undefined)
            setCollapsed(props.defaultCollapsed);
    },[props.defaultCollapsed]);


    return (
        <section style={{display:'flex', flexDirection:'column', gap:'8px'}}>
            <div style={{display:'flex', justifyContent:'space-between'}}>
                {props.header &&
                    <div style={{flexGrow:1}}>
                        {props.header}
                    </div>
                }
                {props.defaultCollapsed !== undefined &&
                    <Button variant='text' 
                        text={collapsed ? 'vis mere' : 'vis mindre'}
                        icon={collapsed ? 'arrows_chevron_chevronDown' : 'arrows_chevron_chevronUp'}
                        onClick={()=>setCollapsed(!collapsed)} />
                }
            </div>
            
            {props.defaultCollapsed === undefined &&
                <div>
                    {props.children}
                </div>
            }
            {props.defaultCollapsed !== undefined &&
                <AnimatedCollapsibleContent open={!collapsed}>       
                    {props.children}
                </AnimatedCollapsibleContent>
        }
        </section>
    );
}

export function PageDividerSection(props:PageSectionProps):JSX.Element
{
    return (
        <PageSection {...props}>
            <Divider />
            {props.children}
        </PageSection>
    );
}

export function PageCardSection(props:PageSectionProps):JSX.Element
{
    return (
        <PageSection {...props}>
            <Card variant="outlined">
                {props.children}
            </Card>
        </PageSection>

    );
}
